import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { SubscriptionBillingStatus } from "../../Objects/Company/SubscriptionBillingStatus"
import { GetRequest } from "../../services/ApiClientService"

export const useSubscriptionBillingStatus = () => {
  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetSubscriptionBillingStatus = async (onSuccess: (data: SubscriptionBillingStatus) => void) => {
    enableLoad()

    try {
      const response = await GetRequest<SubscriptionBillingStatus>(API_ROUTES.SUBSCRIPTION.BILLING_STATUS)

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess(new SubscriptionBillingStatus(response.data ?? {}))
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : "Erro ao consultar status da cobrança."
      setError("Assinatura", message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetSubscriptionBillingStatus,
  }
}
